import type { Action } from 'redux'
import {
  defaultGetParams as getParams,
  payloadAsParam
} from '../../../signalr/helpers'
import type { InvokeDefinition, StreamDefinition } from '../../../signalr/types'
import {
  type TierRevertAction,
  type TierSaveAction,
  revertTierSuccess,
  saveTierFailure,
  saveTierSuccess,
  tierAddTier
} from './actions'
import type { TierList } from './types'

export const fetchTierDefinition: StreamDefinition<[], TierList[], Action> = {
  method: 'GetTiers',
  strategy: 'switch',
  getParams,
  mapResponse: tierAddTier,
  errorAction: 'tiers.fetchFail',
  cancelOn: []
}

export const saveTierDefinition: InvokeDefinition<
  [TierList],
  number,
  TierSaveAction
> = {
  method: 'SaveTier',
  getParams: payloadAsParam,
  mapResponse: (transactionId, action) =>
    saveTierSuccess(action.payload, transactionId),
  mapError: saveTierFailure
}

export const revertTierDefinition: InvokeDefinition<
  [number],
  number,
  TierRevertAction
> = {
  method: 'RevertTier',
  getParams: payloadAsParam,
  mapResponse: (transactionId, action) =>
    revertTierSuccess(action.payload, transactionId),
  mapError: saveTierFailure
}
